import sanitize from "sanitize-html";

const domParser = new DOMParser();

// transform /path/to/file.ext to file.ext
export function basename(path = "") {
  return path ? path.replace(/^.*\//, "") : "";
}

// transform /path/to/file.ext to .ext
export function extname(path = "") {
  const [_, ext] = /.+(\.[^.]+)$/.exec(path) || [];
  return ext || "";
}

// test whether a variable is an object
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

// returns whether a dark theme is enabled
export function isDarkTheme() {
  return document.documentElement.classList.contains("theme-arc-green");
}

// removes duplicate elements in an array
export function uniq(arr) {
  return Array.from(new Set(arr));
}

// strip <tags> from a string
export function stripTags(text) {
  return sanitize(text, {
    allowedTags: [],
  });
}

export function parseDom(text, contentType) {
  return domParser.parseFromString(text, contentType);
}
